import type { Infer } from 'superstruct';
import { array, boolean, number, object, optional, string } from 'superstruct';

import {
	parsableInteger,
	stringDate,
	withMessage,
} from '@adflow/shared/util-superstruct';

export const UploadFacebookTemplateJobData = object({
	templateId: withMessage(parsableInteger(), 'validations:Required'),
	userId: withMessage(parsableInteger(), 'validations:Required'),
});

export const UploadFacebookTemplateAccountJobReport = object({
	adAccountId: number(),
	avbId: string(),
	status: string(),
	errors: array(string()),
	campaigns: optional(
		array(
			object({
				campaignName: string(),
				campaignId: string(),
				salesforceImport: boolean(),
				salesforceSyncStatus: string(),
			})
		)
	),
});

export type UploadFacebookTemplateAccountJobReport = Infer<
	typeof UploadFacebookTemplateAccountJobReport
>;

export const UploadFacebookTemplateJobReport = object({
	templateId: number(),
	startedAt: stringDate(),
	finishedAt: stringDate(),
	results: array(UploadFacebookTemplateAccountJobReport),
});

export type UploadFacebookTemplateJobReport = Infer<
	typeof UploadFacebookTemplateJobReport
>;

export type UploadFacebookTemplateJobData = Infer<
	typeof UploadFacebookTemplateJobData
>;
